import { InjectionKey } from 'vue';
import Validator from './validator';

export const validatorKey = Symbol() as InjectionKey<Validator>;
